import React, { JSX, useEffect } from "react";
import { useMsal, useAccount } from "@azure/msal-react";
import axios from "axios";
import { AuthenticationResult, InteractionRequiredAuthError } from "@azure/msal-browser";
import { loginRequest } from "../authConfig";

interface NetworkInterceptorProps {
  children: JSX.Element;
}

const NetworkInterceptor: React.FC<NetworkInterceptorProps> = ({ children }) => {
  const { instance, accounts } = useMsal();
  const account = useAccount(accounts[0]) || undefined;

  useEffect(() => {
    if (!account) return;

    const requestInterceptor = axios.interceptors.request.use(async (request) => {
      try {
        const tokenResponse = await fetchTokenData();
        request.headers.Authorization = `Bearer ${tokenResponse.accessToken}`;
      } catch (error) {
        if (error instanceof InteractionRequiredAuthError) {
          const tokenResponse = await fetchTokenDataFromPopup();
          request.headers.Authorization = `Bearer ${tokenResponse.accessToken}`;
        } else {
          console.error("Token fetch error:", error);
          throw error;
        }
      }
      return request;
    });

    const responseInterceptor = axios.interceptors.response.use(
      (response) => {
        if (response.status === 201) {
          console.log(response);
        }
        return response;
      },
      (error) => Promise.reject(error)
    );

    // Cleanup interceptors on unmount
    return () => {
      axios.interceptors.request.eject(requestInterceptor);
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, [account, instance]);

  async function fetchTokenData(): Promise<AuthenticationResult> {
    const response: AuthenticationResult = await instance.acquireTokenSilent({
      ...loginRequest,
      account,
    });
    return response;
  }

  async function fetchTokenDataFromPopup(): Promise<AuthenticationResult> {
    const response: AuthenticationResult = await instance.acquireTokenPopup({
      ...loginRequest,
      account,
    });
    return response;
  }

  return <>{children}</>;
};

export default NetworkInterceptor;
